var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AppSection',{attrs:{"id":"invoice-details","type":"page","title":_vm.$getConst.pages.invoice_details.page_title}},[_c('b-container',[_c('InvoiceDetails',{attrs:{"invoice":_vm.invoice,"is-loading":_vm.isLoading}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }